import { Targeting } from "./targeting";

export function toFbJsonString(targeting: Targeting): string {
    const json = targeting.toFbJson();

    let jsonString = JSON.stringify(json);
    jsonString = jsonString.replace(/&/g, " and "); // Avoid API requests to fail

    return jsonString;
}